export const getBooksRespond = state => state.bookReducerState.list

export const getBooksSelection = state => state.bookReducerState.selectedBooks
